export const getQueryParameter = (paramName) => {
  const searchString = window.location.search.substring(1);
  const params = searchString.split('&');

  for (let i = 0; i < params.length; i++) {
    const val = params[i].split('=');
    if (val[0] === paramName) {
      return val[1];
    }
  }
  return null;
};

const TO_REMOVE_PARAMS = ['resend_booking_modal'];
export const removeUnwantedQueries = (queryString) => {
  const params = new URLSearchParams(queryString);
  TO_REMOVE_PARAMS.forEach((p) => {
    if (params.get(p)) {
      params.delete(p);
    }
  });
  const result = params.toString();
  return result ? `?${result}` : '';
}
